import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Alumno } from '../Interfaces/alumno.interface';
import { environment } from 'src/environments/environment';
import { AuthenticatorService, UserType } from './authenticator.service';
import { EstatusService } from '../Modules/AlumnoInfo/Services/estatus.service';
import { Alumno as _Alumno } from '../Modules/AlumnoInfo/Interfaces/alumno.interface';

@Injectable({
    providedIn: 'root',
})
export class AlumnoService {
    private base_url: string = environment.baseUrl;

    constructor(
        private http: HttpClient,
        private auth: AuthenticatorService,
        private estatusService: EstatusService
    ) {}

    getAlumno(numeroControl?: string): Observable<Alumno> {
        const headers = this.auth.headers;

        if (this.auth.expectedRole(UserType.Alumno)) {
            numeroControl = this.auth.user.id;
        }

        const url_api = `${this.base_url}/alumnos/${numeroControl}`;
        return this.http.get<Alumno>(url_api, { headers });
    }

    getAlumnosGenerados(
        periodo: string,
        inicial: number
    ): Observable<Alumno[]> {
        const headers = this.auth.headers;

        const url_api = `${this.base_url}/alumnos-generados/${periodo}/${inicial}`;
        return this.http.get<Alumno[]>(url_api, { headers });
    }

    getAlumnosPosgradoGenerados(
        periodo: string,
        inicial: number
    ): Observable<Alumno[]> {
        const headers = this.auth.headers;

        const url_api = `${this.base_url}/alumnos-posgrado-generados/${periodo}/${inicial}`;
        return this.http.get<Alumno[]>(url_api, { headers });
    }

    updateAlumno(numeroControl: string, alumnoAttrs: Partial<Alumno>) {
        const headers = this.auth.headers;

        const url_api = `${this.base_url}/alumnos/${numeroControl}`;

        return this.http.patch<Alumno>(url_api, alumnoAttrs, { headers });
    }

    getAlumnoAll(filter?: any): Observable<Alumno[]> {
        const headers = this.auth.headers;
        const url_api = `${this.base_url}/alumnos`;
        const options = { headers };

        if (filter) {
            const params = new HttpParams().set(
                'filter',
                JSON.stringify(filter)
            );
            options['params'] = params;
        }

        return this.http.get<Alumno[]>(url_api, options);
    }

    conEspRep(
        carrera: number,
        reticula: number,
        periodo: string
    ): Observable<Alumno[]> {
        const headers = this.auth.headers;
        const url_api = `${this.base_url}/alumno-esp-rep/${carrera}/${reticula}/${periodo}`;

        return this.http.get<Alumno[]>(url_api, { headers });
    }

    porRango(inicial: number, final: number): Observable<_Alumno[]> {
        const headers = this.auth.headers;
        const url_api = `${this.base_url}/alumnos-rango/${inicial}/${final}`;

        return this.http.get<_Alumno[]>(url_api, { headers });
    }
    calculaSemestre(
        periodo: string,
        periodoIngreso: string,
        periodosRevalidados?: number,
        estatus_alumno?: string,
        ultPeriodoIns?: string
    ): number {
        //console.log(periodo);
        if (
            estatus_alumno == 'EGR' ||
            estatus_alumno == 'TIT' ||
            this.estatusService.esBajaDefinitiva(estatus_alumno)
        ) {
            if (parseInt(periodo) > parseInt(ultPeriodoIns))
                periodo = ultPeriodoIns ?? periodo;
        }

        //console.log(periodo);

        const year: number = parseInt(periodo.substr(0, 4));
        const semestre: number = periodo[4] == '3' ? 2 : parseInt(periodo[4]);

        const yearIng: number = parseInt(periodoIngreso.substr(0, 4));
        const semestreIng: number =
            periodoIngreso[4] == '3' ? 2 : parseInt(periodoIngreso[4]);

        return (
            (year - yearIng) * 2 +
            (semestre - semestreIng + 1) +
            (periodosRevalidados ?? 0)
        );
    }

    getPromiseAlumno(numeroControl?: string): Promise<Alumno> {
        const headers = this.auth.headers;

        if (this.auth.expectedRole(UserType.Alumno)) {
            numeroControl = this.auth.user.id;
        }

        const url_api = `${this.base_url}/alumnos/${numeroControl}`;
        return this.http.get<Alumno>(url_api, { headers }).toPromise();
    }

    getAlumnosSubes(): Observable<any[]> {
        const headers = this.auth.headers;
        const url_api = `${this.base_url}/alumnos-subes`;
        const options = { headers };
        return this.http.get<any[]>(url_api, options);
    }

    getAlumnosMatricula(periodo: string): Observable<any[]> {
        const headers = this.auth.headers;
        const url_api = `${this.base_url}/alumnos-matricula/${periodo}`;
        const options = { headers };
        return this.http.get<any[]>(url_api, options);
    }

    getAlumnosPagos(periodo: string, concepto: number): Observable<Alumno[]> {
        const headers = this.auth.headers;
        const url_api = `${this.base_url}/alumnos-pagos/${periodo}/${concepto}`;
        const options = { headers };
        return this.http.get<Alumno[]>(url_api, options);
    }

    getFechaConfirmacionCargaAlumno(
        periodo: string,
        no_de_control: string
    ): Promise<any> {
        const headers = this.auth.headers;
        const url_api = `${this.base_url}/alumno/fecha-confirmacion-carga/${periodo}/${no_de_control}`;
        const options = { headers };
        return this.http.get<any>(url_api, options).toPromise();
    }
}
